module.exports = __webpack_public_path__ + "img/logo.ca9becc2.png";